<p-columnFilter
  #columnFilter
  [field]="field()"
  type="text"
  display="menu"
  matchMode="contains"
  [showMenu]="true"
  [showMatchModes]="false"
  [showOperator]="false"
  [showApplyButton]="false"
  [showAddButton]="false"
>
  <ng-template #filtericon let-hasFilter="hasFilter">
    <i class="pi pi-filter" [class.text-button-red]="hasFilter"></i>
  </ng-template>

  <ng-template #filter let-value let-filterCallback="filterCallback">
    <input
      #input
      type="text"
      pInputText
      class="w-full"
      [value]="value ?? ''"
      (input)="filterCallback(input.value)"
      (keydown.enter)="closeMenu()"
      (keydown.escape)="filterCallback('')"
    />
  </ng-template>
</p-columnFilter>
